import { useState } from 'react';
import './AuditResults.css';

export default function AuditResults({ result }) {
  const [open, setOpen] = useState(false);

  const matched = result?.matched_requirements || [];
  const unmatched = result?.unmatched_requirements || [];
  const decisions = result?.integrity_decisions || [];
  const passed = result?.passed_checks || [];
  const violations = (result?.violations || []).filter(v => v.severity !== 'INFO');

  return (
    <div className="audit-wrap">
      <button className="audit-toggle" onClick={() => setOpen(o => !o)}>
        <span>🔍 View audit details</span>
        <span className="audit-arrow">{open ? '▲' : '▼'}</span>
      </button>

      {open && (
        <div className="audit-body fade-in">
          {/* Matched */}
          {matched.length > 0 && (
            <div className="audit-section">
              <div className="audit-section-title" style={{ color: 'var(--success)' }}>
                ✅ Matched Requirements ({matched.length})
              </div>
              {matched.map((m, i) => (
                <div key={i} className="audit-item audit-match">{m}</div>
              ))}
            </div>
          )}

          {/* Unmatched */}
          {unmatched.length > 0 && (
            <div className="audit-section">
              <div className="audit-section-title" style={{ color: 'var(--text-muted)' }}>
                ⊘ Omitted — Not in your CV ({unmatched.length})
              </div>
              <div className="audit-note">
                These JD requirements were not fabricated — they were simply omitted because they aren't in your CV.
              </div>
              {unmatched.map((u, i) => (
                <div key={i} className="audit-item audit-omit">{u}</div>
              ))}
            </div>
          )}

          {/* Violations */}
          {violations.length > 0 && (
            <div className="audit-section">
              <div className="audit-section-title" style={{ color: 'var(--warning)' }}>
                ⚠️ Warnings ({violations.length})
              </div>
              {violations.map((v, i) => (
                <div key={i} className="audit-item audit-warn">
                  <span className={`severity severity-${v.severity?.toLowerCase()}`}>{v.severity}</span>
                  <div>
                    <div className="violation-issue">{v.issue}</div>
                    {v.recommendation && (
                      <div className="violation-rec">→ {v.recommendation}</div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Integrity decisions */}
          {decisions.length > 0 && (
            <div className="audit-section">
              <div className="audit-section-title">
                🛡️ Integrity Decisions
              </div>
              {decisions.map((d, i) => (
                <div key={i} className="audit-item">{d}</div>
              ))}
            </div>
          )}

          {/* Passed checks */}
          {passed.length > 0 && (
            <div className="audit-section">
              <div className="audit-section-title" style={{ color: 'var(--success)' }}>
                ✓ Checks Passed
              </div>
              {passed.map((p, i) => (
                <div key={i} className="audit-item audit-match">{p}</div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
